import { render, staticRenderFns } from "./Reposicao.vue?vue&type=template&id=5a6ac011&scoped=true&"
import script from "./Reposicao.vue?vue&type=script&lang=js&"
export * from "./Reposicao.vue?vue&type=script&lang=js&"
import style0 from "./Reposicao.vue?vue&type=style&index=0&id=5a6ac011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ac011",
  null
  
)

export default component.exports